import { render, staticRenderFns } from "./addBidangUsaha.vue?vue&type=template&id=f8a7bd0e&scoped=true&"
import script from "./addBidangUsaha.vue?vue&type=script&lang=js&"
export * from "./addBidangUsaha.vue?vue&type=script&lang=js&"
import style0 from "./addBidangUsaha.vue?vue&type=style&index=0&id=f8a7bd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a7bd0e",
  null
  
)

export default component.exports